import React from 'react';
import classnames from 'classnames';
import { noop } from 'lodash';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
 *
 * // render
 * <RadioBox propName='propValue'/>
 */
export const radioBox = ( props ) => {
    
    // dyanmic class name
    const radioClassName = classnames( 'ui-radio-box', props.className, {
        'ui-radio-box--selected': props.selected,
    } );

    const checkClass = classnames(
        'ui-radio-box__check',
        { 'ui-radio-box__check--disabled': props.readOnly }
    );

    return (
        <div className={ radioClassName }>

            {/* input */}
            <input
                tabIndex = { 0 }
                id={ props.name }
                type='radio'
                className={ 'ui-radio-box__input' }
                name={ props.name }
                value={ props.value }
                checked={ props.selected }
                onChange = { props.readOnly ? noop : () => props.onChange( props.value ) }
            />
            
            {/* radio view */}
            <span className={ checkClass } />
        </div>
    );
};

// set display name
radioBox.displayName = 'radioBox';

// set default props
radioBox.defaultProps = {
    name: '',
    value: '',
    readOnly: false,
    selected: false,
    onChange: noop
};

// prop types
radioBox.propTypes = {};
